import React, { useEffect } from 'react';
//@ts-ignore
import { useBranch } from 'baobab-react/hooks';
import * as baobab from '@data/baobab/baobab';
import { useLanguage } from '@base/LanguageProvider';
import { useSelectedSheetRow } from '../../data/sheetRow/sheetRowHooks';
var LineItemsPagination = function (props) {
    var L = useLanguage().L;
    var selectedSheetRow = useSelectedSheetRow();
    var lineItemsPagination = useBranch({
        lineItemsPagination: ['state', 'lineItemsPagination'],
    }).lineItemsPagination;
    useEffect(function () {
        baobab.root.set(['state', 'lineItemsPagination', 'page'], 1);
        return function () { };
    }, [selectedSheetRow]);
    var updatePageSelection = function (pageNum) {
        var num = Number(pageNum);
        var page = baobab.root.select(['state', 'lineItemsPagination', 'page']);
        if (pageNum !== '') {
            if (num >= 1) {
                page.set(num);
            }
            else {
                page.set(1);
            }
        }
        else {
            page.set(1);
        }
    };
    return (React.createElement("div", { className: "list-items-toolbar-item" },
        React.createElement("span", { style: { padding: '8px' } },
            " ",
            L('Page'),
            ":"),
        React.createElement("input", { onChange: function (e) {
                updatePageSelection(e.target.value);
            }, placeholder: "Page", style: { width: '52px' }, type: "number", className: "list-items__search-input ", value: lineItemsPagination.page })));
};
export default LineItemsPagination;
